__turbopack_context__.v({
  "active": "kYxC5q_active",
  "isLabel": "kYxC5q_isLabel",
  "mainNav": "kYxC5q_mainNav",
  "menuItem": "kYxC5q_menuItem",
  "primaryMenu": "kYxC5q_primaryMenu",
  "subMenu": "kYxC5q_subMenu",
  "thirdLevel": "kYxC5q_thirdLevel",
});
